<div class="ap-flex ap-flex-column ap-flex-grow-1 ap-text-align-center ap-padding-top-6 ap-padding-bottom-1">
    <h2>{{ 'conversational.chat.connectionerror.title' | apContent }}</h2>
    <ap-panel type="primary" aria-live="assertive">
        <p ap-panel-body class="ap-text-align-center">
            {{ 'conversational.chat.connectionerror.message' | apContent }}
        </p>
    </ap-panel>
</div>
